import { render, staticRenderFns } from "./ConfirmRegistration.vue?vue&type=template&id=6f223e39&"
import script from "./ConfirmRegistration.vue?vue&type=script&lang=ts&"
export * from "./ConfirmRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports